import { render, staticRenderFns } from "./CustomFieldsForm.vue?vue&type=template&id=72c64cd0&scoped=true&"
import script from "./CustomFieldsForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c64cd0",
  null
  
)

export default component.exports